import axios from "axios";
import {message, Modal, Space} from "antd";
import html2canvas from "html2canvas";
import {LoginStore} from "./components/PlayerLogin";

export const tourneyUrl = (s) => `/tournaments/${gon.tournament.tid}${s}`;

export const idNameToOption = n => [n.id, n.name];

export const genderedAge = pl => !!pl?.age ? `${pl.age}${_.upperCase(pl.gender[0])}` : null;

export const excelRating = (pl, type) => {
  if (!pl)
    return null;

  let r = pl.final_rating && pl.final_rating[type];
  if (r)
    return r.toFixed(1);
}

export const showErr = (title, content) => Modal.error({title, content, zIndex: 8000});

export const juniorsRating = (pl, d) => {
  if (!pl)
    return null;

  let fr = pl.final_rating || pl.wpr;
  if (d.name && d.name.match(/Singles/i))
    return fr?.singles;

  return fr?.doubles;
}

export const applyDrag = (arr, dragResult) => {
  const { removedIndex, addedIndex, payload } = dragResult;
  if (removedIndex === null && addedIndex === null) return arr;

  const result = [...arr];
  let itemToAdd = payload;

  if (removedIndex !== null) {
    itemToAdd = result.splice(removedIndex, 1)[0];
  }

  if (addedIndex !== null) {
    result.splice(addedIndex, 0, itemToAdd);
  }

  return result;
};

export const pp = obj => {
  if (obj)
    console.log(JSON.parse(JSON.stringify(obj)))
  else
    console.log(obj);
}

let spacedMatchNum = (a, b) => <Space size={1}>{a}<div className="text-xs opacity-50">➔</div>{b}</Space>

export const matchFormat = s => {
  if (!s || s.match(/none|unknown/))
    return null;

  if (s === "to_11")
    return spacedMatchNum(1, 11);

  if (s === "to_21")
    return spacedMatchNum(1, 21);

  if (s === "to_11_by_1")
    return spacedMatchNum(1, "11:1");

  return s === "to_15" ? spacedMatchNum(1, 15) : spacedMatchNum("2/3", 11);
}

export const numToTime = (n, noAmPm) => {
  let h = Math.floor(n/100);
  let m = n%100;

  let ampm = h >= 12 ? "pm" : "am";
  if (h > 12)
    h -= 12;

  if (m === 0)
    m = "00";

  if (noAmPm)
    return `${h}:${m}`;
  else
    return `${h}:${m}${ampm}`;
}

export const divPrint = (div, opts) => {
  const originalOverflow = div.style.overflow;
  div.style.overflow = 'visible';

  html2canvas(div, opts).then(canvas => {
    // Convert canvas to image
    const image = canvas.toDataURL("image/png");
    div.style.overflow = originalOverflow;


    // Create a new window for printing
    const printWindow = window.open('', '', 'width=1200,height=800');

    // Write the image to the new window
    printWindow.document.open();
    printWindow.document.write(`
                    <html>
                        <head>
                            <title>Print Image</title>
                            <style>
                                @media print {
                                    img { 
                                        max-width: 100%;
                                        max-height: 100%;
                                    }
                                }
                            </style>
                        </head>
                        <body>
                            <img src="${image}" onload="window.print()">
                        </body>
                    </html>
                `);
    // printWindow.document.close();
  });
}

export const countStr = (s, n, max) => {
  if (typeof(n) != 'number')
    n = n.length;

  if (max)
    n = [n, max].join("/");

  return `${s} (${n})`;
}

export const callWithCatch = async ({url, reload, params, method, onErr, onSuccess, setXhr, setLoading, keepLoading}) => {
  try {
    setXhr = setXhr || setLoading;
    setXhr && setXhr(true);
    method = method || 'get';
    if (method === "get")
      params = { params };

    let data = (await axios[method](url, params)).data;

    if (data.err) {
      if (data.session_expired) {
        Modal.error({title: data.err_title, content: data.err, zIndex: 8000, onOk: () => LoginStore.open('login') });
      }
      else
        Modal.error({title: data.err_title, content: data.err, zIndex: 8000});
      onErr && onErr(data.err);
    }
    else {
      onSuccess && onSuccess(data);

      if (reload)
        window.location.reload() ;
    }
    setXhr && !keepLoading && !reload && setXhr(false);

    return data;
  }
  catch(e) {
    setXhr && setXhr(false);
    Modal.error({title: "Unknown error", content: "Please refresh the page and try again.", zIndex: 8000});
    onErr && onErr(e);
    throw e;
  }
}

export const callAndReload = async ({url, params, method, reload, onSave, onErr, savedMsg, setLoading}) => {
  try {
    if (!setLoading)
      setLoading = () => 1;

    setLoading(true);
    if (method === "get")
      params = { params };
    let data = (await axios[method](url, params)).data;

    if (data.err) {
      if (data.session_expired) {
        Modal.error({title: data.err_title, content: data.err, zIndex: 2000});
        LoginStore.open('login');
      } else {
        Modal.error({title: data.err_title, content: data.err, zIndex: 2000});
      }
      onErr && onErr(data.err);
      setLoading(false);
      return false;
    }
    else {
      window.location.reload() ;
      message.success(savedMsg || "Saved!");
      return true;
    }
  }
  catch(e) {
    setLoading(false);
    message.error("Unknown error, not saved");
    onErr && onErr(e);
    throw e;
  }
}